import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Input, Table, Button, Select, Dropdown, Menu, DatePicker, Modal as AntModal, Spin, message, Space } from "antd";
import { SearchOutlined, PrinterOutlined, DownOutlined, EyeOutlined, EditOutlined, CommentOutlined, UserOutlined, FileAddOutlined, CalendarOutlined } from "@ant-design/icons";
import "antd/dist/antd.css";
import dayjs from "dayjs";
import Cookies from 'js-cookie';
import customParseFormat from "dayjs/plugin/customParseFormat";
import { itemRender, onShowSizeChange } from "../../../../paginationfunction";

import "../../components/caseStyle.css";

import {
    getAllAppealCaseReportApi,
    getDistrictsApi,
    getCourtTypesApi,
    getFinalResultApi,
    getHearingDatesByCaseEntryApi,
    createHearingDateApi,
    deleteHearingDateApi,
    updateCaseEntryCommentApi,
    getResponsibleOfficersApi,
    createResponsibleOfficersApi,
    getDocumentsByCaseEntryApi,
    addDocumentApi,
    deleteDocumentApi
} from "../../../../api/master.api";
import { uploadGeneralCaseFileApi } from "../../../../api/uploadFile.api";
import { useAuth } from "../../../../context/AuthContext";
const { Option } = Select;
const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";
dayjs.extend(customParseFormat);

const AllAppealReport = () => {
    const logInStatus = parseInt(Cookies.get("Role"));
    const { user, logout } = useAuth();
    const toBnDigits = (value) => {
        if (!value) return '';
        const en = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        const bn = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
        let strValue = String(value);
        const num = Number(value);
        if (!isNaN(num) && num >= 1 && num <= 9) {
            strValue = strValue.padStart(2, '0');
        }
        return strValue.replace(/[0-9]/g, d => bn[en.indexOf(d)]);
    };

    const [data, setData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        district: "",
        courtType: "",
        lawOfficer: "",
        caseNo: "",
        caseType: ""
    });
    const [dateRange, setDateRange] = useState(null);
    const [dateRange1, setDateRange1] = useState(null);

    // Modal States
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [finalResultData, setFinalResultData] = useState({});
    const [modalLoading, setModalLoading] = useState(false);

    const [isHearingModalVisible, setIsHearingModalVisible] = useState(false);
    const [selectedCaseId, setSelectedCaseId] = useState(null);
    const [hearingFormData, setHearingFormData] = useState({
        hearing_date: '',
        next_hearing_date: '',
        hearing_notes: ''
    });
    const [hearingDates, setHearingDates] = useState([]);
    const [hearingModalLoading, setHearingModalLoading] = useState(false);

    const [isCommentModalVisible, setIsCommentModalVisible] = useState(false);
    const [commentCaseId, setCommentCaseId] = useState(null);
    const [commentText, setCommentText] = useState('');
    const [commentModalLoading, setCommentModalLoading] = useState(false);
    const getSafeDateValue = (dateString) => {
        if (!dateString) return null;
        return dayjs(dateString, 'YYYY-MM-DD').isValid() ? dayjs(dateString, 'YYYY-MM-DD') : null;
    };

    const [isOfficerModalVisible, setIsOfficerModalVisible] = useState(false);
    const [officerModalLoading, setOfficerModalLoading] = useState(false);
    const [officerCaseId, setOfficerCaseId] = useState(null);
    const [officers, setOfficers] = useState([{ name: '', profession: '', phone: '' }]);

    const [isDocumentModalVisible, setIsDocumentModalVisible] = useState(false);
    const [documentModalLoading, setDocumentModalLoading] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [docFormData, setDocFormData] = useState({ document_name: "", file: null });

    const [districts, setDistricts] = useState([]);
    const [courtTypes, setCourtTypes] = useState([]);

    // Load data on mount
    useEffect(() => {
        loadAppealCases();
        loadDistricts();
        loadCourtTypes();
    }, []);

    const loadAppealCases = async () => {
        setLoading(true);
        try {
            const response = await getAllAppealCaseReportApi();
            if (response.data.success) {
                const items = response.data.data || [];
                setAllData(items);
                setData(items);
            } else {
                message.error("ডাটা লোড করতে সমস্যা হয়েছে");
            }
        } catch (error) {
            console.error('Error loading appeal cases:', error);
            message.error("মামলা লোড করতে ব্যর্থ হয়েছে");
        } finally {
            setLoading(false);
        }
    };

    const loadDistricts = async () => {
        try {
            const response = await getDistrictsApi();
            if (response.data.success) {
                const items = response.data.data || [];
                const options = items.map((item) => ({
                    value: item.district_id,
                    label: `${item.district_name} (${item.division_name})`,
                }));
                setDistricts(options);
            }
        } catch (error) {
            console.error('Error loading districts:', error);
        }
    };

    const loadCourtTypes = async () => {
        try {
            const response = await getCourtTypesApi();
            if (response.data.success) {
                const items = response.data.data || [];
                const options = items.map((item) => ({
                    value: item.court_type_id,
                    label: item.court_type_name,
                }));
                setCourtTypes(options);
            }
        } catch (error) {
            console.error('Error loading court types:', error);
        }
    };

    const handleFilterChange = (field, value) => {
        setFilters(prev => ({ ...prev, [field]: value }));
    };

    const handleSearch = () => {
        setLoading(true);
        const trimmedCaseNo = (filters.caseNo || "").trim().toLowerCase();
        const [startDate, endDate] = dateRange || [];
        const startTs = startDate ? dayjs(startDate).startOf('day').valueOf() : null;
        const endTs = endDate ? dayjs(endDate).endOf('day').valueOf() : null;
        const [startDate1, endDate1] = dateRange1 || [];
        const startTs1 = startDate1 ? dayjs(startDate1).startOf('day').valueOf() : null;
        const endTs1 = endDate1 ? dayjs(endDate1).endOf('day').valueOf() : null;

        const filtered = (allData || []).filter((item) => {
            if (filters.district && String(item.district_id) !== String(filters.district)) return false;
            if (filters.courtType && String(item.court_type_id) !== String(filters.courtType)) return false;
            if (trimmedCaseNo && !String(item.case_number || "").toLowerCase().includes(trimmedCaseNo)) return false;
            if (filters.caseType && String(item.case_type_id || "") !== String(filters.caseType)) return false;

            if (startTs && endTs) {
                const itemDate = item.next_hearing_date ? dayjs(item.next_hearing_date, ["YYYY-MM-DD", "DD/MM/YYYY"]) : null;
                if (!itemDate || !itemDate.isValid()) return false;
                const itemTs = itemDate.startOf('day').valueOf();
                if (itemTs < startTs || itemTs > endTs) return false;
            }

            if (startTs1 && endTs1) {
                const itemDate1 = item.filing_date ? dayjs(item.filing_date, ["YYYY-MM-DD", "DD/MM/YYYY"]) : null;
                if (!itemDate1 || !itemDate1.isValid()) return false;
                const itemTs1 = itemDate1.startOf('day').valueOf();
                if (itemTs1 < startTs1 || itemTs1 > endTs1) return false;
            }
            return true;
        });

        setData(filtered);
        setLoading(false);
    };

    const fetchFinalResultData = async (caseEntryId) => {
        setModalLoading(true);
        try {
            const response = await getFinalResultApi(caseEntryId);
            if (response.data.success) {
                setFinalResultData(response.data.data || {});
                setIsModalVisible(true);
            } else {
                message.error("চূড়ান্ত রায় তথ্য লোড করতে ব্যর্থ");
            }
        } catch (error) {
            console.error('Error fetching final result:', error);
            message.error("একটি ত্রুটি হয়েছে");
        } finally {
            setModalLoading(false);
        }
    };

    // Hearing Date Functions
    const handleHearingDateClick = async (record) => {
        setSelectedCaseId(record.case_entry_id);
        setIsHearingModalVisible(true);
        setHearingModalLoading(true);
        try {
            const response = await getHearingDatesByCaseEntryApi(record.case_entry_id);
            if (response.data.success) {
                setHearingDates(response.data.data || []);
            } else {
                setHearingDates([]);
            }
        } catch (err) {
            console.error('Error fetching hearing dates:', err);
            setHearingDates([]);
            message.error("শুনানি তারিখ লোড করতে ব্যর্থ");
        } finally {
            setHearingModalLoading(false);
        }
    };

    const handleHearingFormSubmit = async () => {
        if (!hearingFormData.hearing_date) {
            message.warning('সর্বশেষ শুনানির তারিখ ফিল্ড পূরণ করুন');
            return;
        }
        setHearingModalLoading(true);
        try {
            const response = await createHearingDateApi({
                case_entry_id: selectedCaseId,
                hearing_date: hearingFormData.hearing_date,
                next_hearing_date: hearingFormData.next_hearing_date,
                hearing_notes: hearingFormData.hearing_notes
            });
            if (response.data.success) {
                message.success('শুনানি তারিখ সফলভাবে যোগ করা হয়েছে');
                const refreshResponse = await getHearingDatesByCaseEntryApi(selectedCaseId);
                if (refreshResponse.data.success) {
                    setHearingDates(refreshResponse.data.data || []);
                }
                setHearingFormData({ hearing_date: '', next_hearing_date: '', hearing_notes: '' });
            } else {
                message.error('শুনানি তারিখ যোগ করতে ব্যর্থ');
            }
        } catch (err) {
            console.error('Error adding hearing date:', err);
            message.error('একটি ত্রুটি হয়েছে');
        } finally {
            setHearingModalLoading(false);
        }
    };

    const handleDeleteHearingDate = async (hearingId) => {
        try {
            const response = await deleteHearingDateApi(hearingId);
            if (response.data.success) {
                message.success('শুনানি তারিখ মুছে ফেলা হয়েছে');
                const refreshResponse = await getHearingDatesByCaseEntryApi(selectedCaseId);
                if (refreshResponse.data.success) {
                    setHearingDates(refreshResponse.data.data || []);
                }
            } else {
                message.error('শুনানি তারিখ মুছতে ব্যর্থ');
            }
        } catch (err) {
            console.error('Error deleting hearing date:', err);
            message.error('একটি ত্রুটি হয়েছে');
        }
    };

    // Comment Functions
    const handleCommentClick = async (record) => {
        setCommentCaseId(record.case_entry_id);
        setCommentText(record.case_comment || '');
        setIsCommentModalVisible(true);
    };

    const handleCommentSubmit = async () => {
        if (!commentText.trim()) {
            message.warning('মন্তব্য ফিল্ড পূরণ করুন');
            return;
        }
        setCommentModalLoading(true);
        try {
            const response = await updateCaseEntryCommentApi({
                case_entry_id: commentCaseId,
                case_comment: commentText.trim()
            });
            if (response.data.success) {
                message.success('মন্তব্য সফলভাবে আপডেট করা হয়েছে');
                setIsCommentModalVisible(false);
                loadAppealCases();
            } else {
                message.error('মন্তব্য আপডেট করতে ব্যর্থ');
            }
        } catch (err) {
            console.error('Error updating comment:', err);
            message.error('একটি ত্রুটি হয়েছে');
        } finally {
            setCommentModalLoading(false);
        }
    };

    // Responsible Officers Functions
    const handleResponsibleOfficerClick = async (record) => {
        setOfficerCaseId(record.case_entry_id);
        setIsOfficerModalVisible(true);
        setOfficerModalLoading(true);
        try {
            const response = await getResponsibleOfficersApi(record.case_entry_id);
            if (response.data.success) {
                const items = response.data.data || [];
                const mapped = items.map(item => ({
                    name: item.name || '',
                    profession: item.profession || '',
                    phone: item.phone || ''
                }));
                setOfficers(mapped.length ? mapped : [{ name: '', profession: '', phone: '' }]);
            } else {
                setOfficers([{ name: '', profession: '', phone: '' }]);
            }
        } catch (err) {
            console.error('Error fetching responsible officers:', err);
            setOfficers([{ name: '', profession: '', phone: '' }]);
            message.error("কর্মকর্তার তথ্য লোড করতে ব্যর্থ");
        } finally {
            setOfficerModalLoading(false);
        }
    };

    const handleSaveResponsibleOfficers = async () => {
        const cleaned = officers
            .map(o => ({ name: o.name.trim(), profession: o.profession.trim(), phone: o.phone.trim() }))
            .filter(o => o.name || o.profession || o.phone);
        if (!cleaned.length) {
            message.warning('কমপক্ষে একটি সারিতে তথ্য দিন');
            return;
        }
        setOfficerModalLoading(true);
        try {
            const response = await createResponsibleOfficersApi({
                case_entry_id: officerCaseId,
                officers: cleaned
            });
            if (response.data.success) {
                message.success('দায়িত্বপ্রাপ্ত কর্মকর্তাদের তথ্য সংরক্ষণ করা হয়েছে');
                setIsOfficerModalVisible(false);
            } else {
                message.error('তথ্য সংরক্ষণ ব্যর্থ হয়েছে');
            }
        } catch (err) {
            console.error('Error saving responsible officers:', err);
            message.error('একটি ত্রুটি হয়েছে');
        } finally {
            setOfficerModalLoading(false);
        }
    };

    const addOfficerRow = () => {
        setOfficers([...officers, { name: '', profession: '', phone: '' }]);
    };

    const removeOfficerRow = (index) => {
        setOfficers(officers.filter((_, i) => i !== index));
    };

    const updateOfficerField = (index, field, value) => {
        const newOfficers = [...officers];
        newOfficers[index][field] = value;
        setOfficers(newOfficers);
    };

    // Document Functions
    const handleDocumentEntryClick = async (record) => {
        setSelectedCaseId(record.case_entry_id);
        setIsDocumentModalVisible(true);
        setDocumentModalLoading(true);
        try {
            const response = await getDocumentsByCaseEntryApi(record.case_entry_id);
            if (response.data.success) {
                setDocuments(response.data.data || []);
            } else {
                setDocuments([]);
            }
        } catch (err) {
            console.error("Document fetch error:", err);
            setDocuments([]);
            message.error("ডকুমেন্ট লোড করতে ব্যর্থ");
        } finally {
            setDocumentModalLoading(false);
        }
    };

    const handleDocumentSubmit = async () => {
        if (!docFormData.document_name || !docFormData.file) {
            message.warning("ডকুমেন্ট নাম ও ফাইল দুটোই দিতে হবে");
            return;
        }
        setDocumentModalLoading(true);
        try {
            const uploadRes = await uploadGeneralCaseFileApi(docFormData.file);
            const filePath = uploadRes.data?.data?.filePath;
            if (!filePath) {
                throw new Error("Upload did not return filePath");
            }

            const response = await addDocumentApi({
                case_entry_id: selectedCaseId,
                document_name: docFormData.document_name,
                file_url: filePath
            });

            if (response.data.success) {
                message.success("ডকুমেন্ট সফলভাবে যোগ করা হয়েছে");
                const refreshResponse = await getDocumentsByCaseEntryApi(selectedCaseId);
                if (refreshResponse.data.success) {
                    setDocuments(refreshResponse.data.data || []);
                }
                setDocFormData({ document_name: "", file: null });
            } else {
                message.error("ডকুমেন্ট যোগ করতে ব্যর্থ");
            }
        } catch (err) {
            console.error(err);
            message.error("ত্রুটি হয়েছে");
        } finally {
            setDocumentModalLoading(false);
        }
    };

    const handleDeleteDocument = async (docId) => {
        try {
            const response = await deleteDocumentApi(docId);
            if (response.data.success) {
                message.success("ডকুমেন্ট মুছে ফেলা হয়েছে");
                setDocuments(prev => prev.filter(doc => doc.file_id !== docId));
            } else {
                message.error("ডকুমেন্ট মুছতে ব্যর্থ");
            }
        } catch (err) {
            console.error(err);
            message.error("একটি ত্রুটি হয়েছে");
        }
    };

    const getActionMenu = (record) => (
        <Menu>
            <Menu.Item key="view" >
                <Link style={{ textDecoration: "none" }} to={`/report/single-appeal-case/view/${record.case_entry_id}`}>বিস্তারিত তথ্য</Link>
            </Menu.Item>

{
                user.role === "admin" && (<> <Menu.Item key="update" >
                    <Link style={{ textDecoration: "none" }} to={`/appeal-court-case-update/${record.case_entry_id}`}>সংশোধন</Link>
                </Menu.Item>

                    <Menu.Item key="edit" >
                        <Link style={{ textDecoration: "none" }} to={`/final-result/${record.case_entry_id}`}>চূড়ান্ত রায়</Link>
                    </Menu.Item>
                    <Menu.Item key="hearing" onClick={() => handleHearingDateClick(record)}>শুনানি তারিখ</Menu.Item>
                    <Menu.Item key="finalResult" onClick={() => fetchFinalResultData(record.case_entry_id)}>চূড়ান্ত রায় বিস্তারিত</Menu.Item>

                    <Menu.Item key="comment" onClick={() => handleCommentClick(record)}>মন্তব্য</Menu.Item>
                    <Menu.Item key="responsibleOfficer" onClick={() => handleResponsibleOfficerClick(record)}>দায়িত্বপ্রাপ্ত কর্মকর্তা</Menu.Item>
                    <Menu.Item key="documentEntry" onClick={() => handleDocumentEntryClick(record)}>ডকুমেন্ট এন্ট্রি</Menu.Item></>)
}

           

        </Menu>
    );

    const columns = [
        { title: "ক্রম", className: "case_column_bg", key: "serial", width: 80, align: "center", render: (_, __, index) => index + 1 },
        { title: "মামলা নং", dataIndex: "case_number", className: "case_column_bg", key: "case_number", width: 140, align: "center", render: (text) => text },
        { title: "সংশ্লিষ্ট আদালতের নাম", className: "case_column_bg", key: "court", width: 150, align: "left", render: (_, record) => (<div>{record.ha_case_court_name}<br />{record.ha_case_justice_name}</div>) },
        { title: "সরকারের প্রতিপক্ষের নাম", dataIndex: "petitioner_name", className: "case_column_bg", key: "petitioner_name", width: 180, align: "left" },
        { title: "মামলাভুক্ত সংশ্লিষ্ট মুখ্য দপ্তর", dataIndex: "appelier", className: "case_column_bg", key: "appelier", width: 180, align: "left" },
        { title: "মামলার বিষয়বস্তু", dataIndex: "case_description", className: "case_column_bg", key: "case_description", width: 180, align: "left" },
        { title: "সর্বশেষ অবস্থা", className: "case_column_bg", key: "status", width: 150, align: "center", render: (_, record) => (<div>{record.hearing_date ? `সর্বশেষ শুনানীর তারিখ: ${record.hearing_date}` : ""}{record.next_hearing_date ? <><br />পরবর্তী শুনানীর তারিখ: {record.next_hearing_date}</> : ""}</div>) },
        { title: "অবস্থা", className: "case_column_bg", key: "case_status", width: 150, align: "center", render: (_, record) => (<div>{record.case_status === 1 ? "মামলা চলমান" : "নিষ্পত্তিকৃত মামলা"}<br />{record.case_comment ? ` ও ${record.case_comment}` : ""}</div>) },
        { title: "অ্যাকশন", className: "case_column_bg", key: "action", width: 120, align: "center", render: (_, record) => (<Dropdown overlay={getActionMenu(record)} trigger={['click']}><Button type="primary" size="small" style={{ backgroundColor: '#52c41a' }}>অ্যাকশন <DownOutlined /></Button></Dropdown>) }
    ];

    const generatePrintContent = () => {
        return `<!DOCTYPE html><html><head><meta charset="utf-8"><style>
            body { margin: 0; padding: 20px; font-size: 12px; font-family: 'Nikosh', 'SolaimanLipi', Arial, sans-serif; }
            .header { text-align: center; margin-bottom: 30px; }
            .header-text { margin: 5px 0; font-weight: bold; }
            .main-title { font-size: 14px; font-weight: bold; margin: 10px 0; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #000; padding: 5px; text-align: center; vertical-align: top; font-size: 12px; }
            th { background-color: #f5f5f5; font-weight: bold; }
            @media print { body { print-color-adjust: exact; } }
        </style></head><body>
            <div class="header">
                <div class="header-text">সড়ক পরিবহন ও সেতু মন্ত্রণালয়</div>
                <div class="header-text">বাংলাদেশ সেতু কর্তৃপক্ষ</div>
                <div class="header-text">প্রশাসন শাখা</div>
                <div class="main-title">আপিল বিভাগের সকল মামলার তালিকা:</div>
            </div>
            <table><thead><tr><th>ক্রম</th><th>মামলার নম্বর</th><th>সংশ্লিষ্ট আদালতের নাম</th><th>সরকারের প্রতিপক্ষের নাম</th><th>মামলাভুক্ত সংশ্লিষ্ট মুখ্য দপ্তর</th><th>বিষয় সংক্ষেপে</th><th>মামলার সর্বশেষ অবস্থা</th><th>সংশ্লিষ্ট আইনজীবীর নাম</th></tr></thead>
            <tbody>${data.map((item, index) => `<tr><td>${index + 1}</td><td>${item.case_number}</td><td>${item.ha_case_court_name || ''} ${item.ha_case_justice_name || ''}</td><td>${item.petitioner_name || ''}</td><td>${item.appelier || ''}</td><td>${item.case_description || ''}</td><td>${item.hearing_date ? `সর্বশেষ শুনানী: ${item.hearing_date}` : ''} ${item.next_hearing_date ? `পরবর্তী: ${item.next_hearing_date}` : ''}</td><td>${item.law_officers || ''} ${item.officer_names || ''}</td></tr>`).join('')}</tbody>
            </table></body></html>`;
    };

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        if (printWindow) {
            printWindow.document.write(generatePrintContent());
            printWindow.document.close();
            printWindow.onload = () => setTimeout(() => printWindow.print(), 500);
        }
    };

    return (
        <div className="page-wrapper">
            <Helmet><title>আপিল বিভাগের সকল মামলার তালিকা</title></Helmet>
            <div className="content">
                <div className="page-header">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3 className="page-title text-center mb-4"><strong>আপিল বিভাগের সকল মামলার তালিকা</strong></h3>
                        </div>
                    </div>
                </div>

                  <div className="row mb-4 action-buttons">
                    <div className="col-sm-12 text-end">
                         <Button
                            type="danger"
                            style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: 'white' }}
                            onClick={handlePrint}
                            icon={<PrinterOutlined style={{ fontSize: 20 }} />}
                            iconPosition="start"
                            className="print-button"
                        >
                            প্রিন্ট
                        </Button>
                    </div>
                </div>

                <div className="filter-section">
                    <div className="row mb-3">
                        <div className="col-md-3 mb-3">
                            <label className="form-label">মামলা নং</label>
                            <Input placeholder="মামলা নং" value={filters.caseNo} onChange={(e) => handleFilterChange('caseNo', e.target.value)} style={{ height: 36 }} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label className="form-label">পরবর্তী শুনানীর তারিখ</label>
                            <RangePicker value={dateRange} onChange={setDateRange} format={dateFormat} allowClear style={{ width: '100%' }} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label className="form-label">মামলা দায়েরের তারিখ</label>
                            <RangePicker value={dateRange1} onChange={setDateRange1} format={dateFormat} allowClear style={{ width: '100%' }} />
                        </div>
                        <div className="col-md-3 mb-3 d-flex align-items-end">
                            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch} loading={loading} style={{ backgroundColor: '#52c41a' }}>অনুসন্ধান করুন</Button>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <Table columns={columns} dataSource={data} loading={loading} bordered size="large" rowKey="case_entry_id" />
                    </div>
                </div>
            </div>

            {/* Final Result Modal */}
            <AntModal title="চূড়ান্ত রায় বিস্তারিত" open={isModalVisible} onCancel={() => setIsModalVisible(false)} footer={null} width={700}>
                {modalLoading ? <Spin /> : finalResultData ? (
                    <div>
                        <div className="mb-3"><strong>মামলা নং:</strong> {finalResultData.case_number}</div>
                        <div className="mb-3"><strong>আদালত:</strong> {finalResultData.court_type_name}</div>
                        <div className="mb-3"><strong>রায় ঘোষণার তারিখ:</strong> {finalResultData.judgment_date}</div>
                        <div className="mb-3"><strong>ফলাফল:</strong> {finalResultData.outcome_code === 'GOVT_FOR' ? 'সরকারের পক্ষে' : finalResultData.outcome_code === 'GOVT_AGAINST' ? 'সরকারের বিপক্ষে' : 'N/A'}</div>
                        {finalResultData.summary_text && <div className="mb-3"><strong>রায়ের সংক্ষিপ্ত বিবরণ:</strong><br />{finalResultData.summary_text}</div>}
                    </div>
                ) : <div className="text-center">কোনো তথ্য পাওয়া যায়নি</div>}
            </AntModal>

            {/* Hearing Date Modal */}
            <AntModal title="শুনানি তারিখ যোগ করুন" open={isHearingModalVisible} onCancel={() => setIsHearingModalVisible(false)} footer={null} width={700}>
                {hearingModalLoading ? <Spin /> : (
                    <>
                        <div className="row mb-3">
                            <div className="col-md-6"><label>সর্বশেষ শুনানির তারিখ <span className="text-danger">*</span></label>
                                <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" value={hearingFormData.hearing_date ? dayjs(hearingFormData.hearing_date) : null} onChange={(date) => setHearingFormData({ ...hearingFormData, hearing_date: date ? date.format('YYYY-MM-DD') : '' })} />
                            </div>
                            <div className="col-md-6"><label>পরবর্তী শুনানির তারিখ</label>
                                <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" value={hearingFormData.next_hearing_date ? dayjs(hearingFormData.next_hearing_date) : null} onChange={(date) => setHearingFormData({ ...hearingFormData, next_hearing_date: date ? date.format('YYYY-MM-DD') : '' })} />
                            </div>
                        </div>
                        <div className="mb-3"><label>মন্তব্য</label><Input.TextArea rows={3} value={hearingFormData.hearing_notes} onChange={(e) => setHearingFormData({ ...hearingFormData, hearing_notes: e.target.value })} /></div>
                        <Button type="primary" onClick={handleHearingFormSubmit}>যোগ করুন</Button>
                        <hr />
                        <h5>বিদ্যমান শুনানি তারিখসমূহ</h5>
                        <Table dataSource={hearingDates} rowKey="hearing_id" pagination={false} size="small" columns={[{ title: 'ক্রম', render: (_, __, i) => i + 1 }, { title: 'তারিখ', dataIndex: 'hearing_date', render: (d) => d }, { title: 'মন্তব্য', dataIndex: 'hearing_notes' }, { title: 'অ্যাকশন', render: (_, record) => <Button danger size="small" onClick={() => handleDeleteHearingDate(record.hearing_id)}>মুছুন</Button> }]} />
                    </>
                )}
            </AntModal>

            {/* Comment Modal */}
            <AntModal title="মন্তব্য যোগ করুন/সম্পাদনা করুন" open={isCommentModalVisible} onCancel={() => setIsCommentModalVisible(false)} footer={null}>
                <Input.TextArea rows={6} value={commentText} onChange={(e) => setCommentText(e.target.value)} placeholder="মামলার বিষয়ে আপনার মন্তব্য লিখুন..." />
                <div className="mt-3"><Button type="primary" loading={commentModalLoading} onClick={handleCommentSubmit}>আপডেট করুন</Button></div>
            </AntModal>

            {/* Responsible Officers Modal */}
            <AntModal title="দায়িত্বপ্রাপ্ত কর্মকর্তা" open={isOfficerModalVisible} onCancel={() => setIsOfficerModalVisible(false)} footer={null} width={800}>
                {officerModalLoading ? <Spin /> : (
                    <>
                        <Table dataSource={officers} pagination={false} size="small" columns={[
                            { title: 'কর্মকর্তার নাম', render: (_, __, i) => <Input value={officers[i]?.name} onChange={(e) => updateOfficerField(i, 'name', e.target.value)} placeholder="কর্মকর্তার নাম" /> },
                            { title: 'পদবি', render: (_, __, i) => <Input value={officers[i]?.profession} onChange={(e) => updateOfficerField(i, 'profession', e.target.value)} placeholder="পদবি" /> },
                            { title: 'নম্বর', render: (_, __, i) => <Input value={officers[i]?.phone} onChange={(e) => updateOfficerField(i, 'phone', e.target.value)} placeholder="মোবাইল নম্বর" /> },
                            { title: 'অ্যাকশন', render: (_, __, i) => <Button danger size="small" onClick={() => removeOfficerRow(i)}>মুছুন</Button> }
                        ]} />
                        <div className="mt-3"><Space><Button onClick={addOfficerRow}>আরও যোগ করুন</Button><Button type="primary" onClick={handleSaveResponsibleOfficers}>সংরক্ষণ করুন</Button></Space></div>
                    </>
                )}
            </AntModal>

            {/* Document Modal */}
            <AntModal title="ডকুমেন্ট যোগ করুন" open={isDocumentModalVisible} onCancel={() => setIsDocumentModalVisible(false)} footer={null} width={800}>
                {documentModalLoading ? <Spin /> : (
                    <>
                        <div className="row mb-3">
                            <div className="col-md-6"><Input placeholder="ডকুমেন্ট নাম" value={docFormData.document_name} onChange={(e) => setDocFormData({ ...docFormData, document_name: e.target.value })} /></div>
                            <div className="col-md-6"><input type="file" className="form-control" onChange={(e) => setDocFormData({ ...docFormData, file: e.target.files[0] })} /></div>
                        </div>
                        <Button type="primary" onClick={handleDocumentSubmit}>যোগ করুন</Button>
                        <hr />
                        <h5>বিদ্যমান ডকুমেন্টসমূহ</h5>
                        <Table dataSource={documents} rowKey="file_id" pagination={false} size="small" columns={[
                            { title: 'ক্রম', render: (_, __, i) => i + 1 },
                            { title: 'ডকুমেন্ট নাম', dataIndex: 'file_name' },
                            { title: 'ফাইল', render: (_, r) => { const apiBase = process.env.REACT_APP_API_URL || 'https://scms.infotechitsolutionsbd.com/'; return <a href={`${apiBase}${r.file_url}`} target="_blank" rel="noopener noreferrer">দেখুন</a>; } },
                            { title: 'অ্যাকশন', render: (_, r) => <Button danger size="small" onClick={() => handleDeleteDocument(r.file_id)}>ডিলিট</Button> }
                        ]} />
                    </>
                )}
            </AntModal>
        </div>
    );
};

export default AllAppealReport;